import { TenderConfigOptions, TenderMethod } from '@rygen/rygen-ui/model';

export class WaterfallTenderRateQuoteConfig {
  rateQuoteId?: number;
  tenderMethod?: TenderMethod;
  tenderConfigOptions: TenderConfigOptions = new TenderConfigOptions();
  sequenceNumber: number = 1;

  constructor(opts?: Partial<WaterfallTenderRateQuoteConfig>) {
    if (opts?.rateQuoteId != null) {
      this.rateQuoteId = opts.rateQuoteId;
    }
    if (opts?.tenderMethod != null) {
      if (typeof opts?.tenderMethod === 'string') {
        this.tenderMethod = TenderMethod[opts.tenderMethod];
      } else {
        this.tenderMethod = opts.tenderMethod;
      }
    }
    if (opts?.tenderConfigOptions != null) {
      this.tenderConfigOptions = new TenderConfigOptions(
        opts.tenderConfigOptions,
      );
    }
    if (opts?.sequenceNumber != null) {
      this.sequenceNumber = opts.sequenceNumber;
    }
  }
}
